<template>
    <div class="kx-home-content-box" >
        <div v-show="showMode === 'kxjList'">
            <div class="kx-head-container">
                <div class="kx-left-head-container" @click="backHome">
                    <svg t="1766639305795"  class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12595" width="28" height="28"><path d="M512 512m-465.454545 0a465.454545 465.454545 0 1 0 930.90909 0 465.454545 465.454545 0 1 0-930.90909 0Z" fill="#e6e6e6" p-id="12596"></path><path d="M512 1024C229.236364 1024 0 794.763636 0 512S229.236364 0 512 0s512 229.236364 512 512-229.236364 512-512 512zM443.904 515.258182l205.637818-205.637818a58.181818 58.181818 0 1 0-82.292363-82.292364l-246.830546 246.830545a58.181818 58.181818 0 0 0 2.606546 84.712728l244.31709 244.363636a58.181818 58.181818 0 1 0 82.292364-82.292364l-205.730909-205.730909z" fill="#0d55a4" p-id="12597" data-spm-anchor-id="a313x.search_index.0.i5.3a373a81dKtAXk" class="selected"></path></svg>
                </div>
                <div class="kx-right-head-container">中国科学家榜样</div>
                <div class="kx-left-head-container">
                </div>
            </div>
            <div class="home-img-container" style="padding-bottom: 30px;">
                <div class="home-line-container" >
                    <div class="home-kx-line-item mr-line" @click="jumpScModel('中国科技崛起的精神内核')">
                        <div class="hc-1" >
                            <img class="line-img-100" src="../../assets/bymy/中国科技崛起的精神内核.png" alt="中国科技崛起的精神内核">
                        </div>
                    </div>
                    <div class="home-kx-line-item mr-line" @click="jumpScModel('钱学森系列')">
                        <div class="hc-1" >
                            <img class="line-img-100" src="../../assets/bymy/钱学森系列.png" alt="钱学森系列">
                        </div>
                        

                    </div>
                    <div class="home-kx-line-item mr-line" @click="jumpScModel('邓稼先系列')">
                        <div class="hc-1" >
                            <img class="line-img-100" src="../../assets/bymy/邓稼先系列.png" alt="邓稼先系列">
                        </div>
                        

                    </div>
                    <div class="home-kx-line-item" @click="jumpScModel('于敏系列')">
                        <div class="hc-1" >
                            <img class="line-img-100" src="../../assets/bymy/于敏系列.png" alt="于敏系列">
                        </div>
                        

                    </div>
                </div>
                <div class="home-line-container">
                    <div class="home-kx-line-item mr-line" @click="jumpScModel('郭永怀系列')">
                        <div class="hc-1" >
                            <img class="line-img-100" src="../../assets/bymy/郭永怀系列.png" alt="郭永怀系列">
                        </div>
                        

                    </div>
                    <div class="home-kx-line-item mr-line" @click="jumpScModel('王淦昌系列')">
                        <div class="hc-1" >
                            <img class="line-img-100" src="../../assets/bymy/王淦昌系列.png" alt="王淦昌系列">
                        </div>
                        

                    </div>
                    <div class="home-kx-line-item mr-line" @click="jumpScModel('钱三强系列')">
                        <div class="hc-1" >
                            <img class="line-img-100" src="../../assets/bymy/钱三强系列.png" alt="钱三强系列">
                        </div>
                        

                    </div>
                    <div class="home-kx-line-item" @click="jumpScModel('钱伟长系列')">
                        <div class="hc-1" >
                            <img class="line-img-100" src="../../assets/bymy/钱伟长系列.png" alt="钱伟长系列">
                        </div>
                        

                    </div>
                </div>
                <div class="home-line-container">
                    <div class="home-kx-line-item mr-line" @click="jumpScModel('詹天佑系列')">
                        <div class="hc-1" >
                            <img class="line-img-100" src="../../assets/bymy/詹天佑系列.png" alt="詹天佑系列">
                        </div>
                        

                    </div>
                    <div class="home-kx-line-item mr-line" @click="jumpScModel('茅以升系列')">
                        <div class="hc-1" >
                            <img class="line-img-100" src="../../assets/bymy/茅以升系列.png" alt="茅以升系列">
                        </div>
                        

                    </div>
                    <div class="home-kx-line-item mr-line" @click="jumpScModel('陈景润系列')">
                        <div class="hc-1" >
                            <img class="line-img-100" src="../../assets/bymy/陈景润系列.png" alt="陈景润系列">
                        </div>
                        

                    </div>
                    <div class="home-kx-line-item" @click="jumpScModel('华罗庚系列')">
                        <div class="hc-1" >
                            <img class="line-img-100" src="../../assets/bymy/华罗庚系列.png" alt="华罗庚系列">
                        </div>
                        

                    </div>
                </div>
                <div class="home-line-container">
                    <div class="home-kx-line-item mr-line" @click="jumpScModel('李四光系列')">
                        <div class="hc-1" >
                            <img class="line-img-100" src="../../assets/bymy/李四光系列.png" alt="李四光系列">
                        </div>
                        

                    </div>
                    <div class="home-kx-line-item mr-line" @click="jumpScModel('竺可桢系列')">
                        <div class="hc-1" >
                            <img class="line-img-100" src="../../assets/bymy/竺可桢系列.png" alt="竺可桢系列">
                        </div>
                        

                    </div>
                    <div class="home-kx-line-item mr-line" @click="jumpScModel('袁隆平系列')">
                        <div class="hc-1" >
                            <img class="line-img-100" src="../../assets/bymy/袁隆平系列.png" alt="袁隆平系列">
                        </div>
                        

                    </div>
                    <div class="home-kx-line-item" @click="jumpScModel('屠呦呦系列')">
                        <div class="hc-1" >
                            <img class="line-img-100" src="../../assets/bymy/屠呦呦系列.png" alt="屠呦呦系列">
                        </div>
                        

                    </div>
                </div>
                <div class="home-line-container">
                    <div class="home-kx-line-item mr-line" @click="jumpScModel('黄旭华系列')">
                        <div class="hc-1" >
                            <img class="line-img-100" src="../../assets/bymy/黄旭华系列.png" alt="黄旭华系列">
                        </div>
                        

                    </div>
                    <div class="home-kx-line-item mr-line" @click="jumpScModel('黄大年系列')">
                        <div class="hc-1" >
                            <img class="line-img-100" src="../../assets/bymy/黄大年系列.png" alt="黄大年系列">
                        </div>
                        

                    </div>
                    <div class="home-kx-line-item mr-line" @click="jumpScModel('宋文骢（歼10战机之父）系列')">
                        <div class="hc-1" >
                            <img class="line-img-100" src="../../assets/bymy/宋文骢系列.png" alt="宋文骢系列">
                        </div>
                        

                    </div>
                    <div class="home-kx-line-item" @click="jumpScModel('南仁东系列')">
                        <div class="hc-1" >
                            <img class="line-img-100" src="../../assets/bymy/南仁东系列.png" alt="南仁东系列">
                        </div>
                        

                    </div>
                </div>
                <div class="home-line-container">
                    <div class="home-kx-line-item mr-line" @click="jumpScModel('其他科学家')">
                        <div class="hc-1" >
                            <img class="line-img-100" src="../../assets/bymy/其他科学家.png" alt="其他科学家">
                        </div>
                        

                    </div>
                </div>
            </div>
        </div>
        <!-- 模块视频列表 -->
        <div  v-show="this.showMode === 'list'" id="top-mode">
            <hum-video-list-kxj-mode :cname="this.categoryName"  @change-home-mode="changeHomeMode"/>
        </div>
    </div>
</template>

<script>
import { timestampToTime } from "@/utils/date";
import humVideoListKxjMode from "@/components/home/humVideoListKxjMode.vue";
export default {
    name: "humKxjMode",
    components: {humVideoListKxjMode},
    props:{},
    watch:{},
    data() {
        return {
            timestampToTime,
            showMode:'kxjList',
            categoryName:'',
        };
    },
    created() {},
    mounted() {
    },
    computed: {},
    methods: {
        backHome(){
            this.$emit('change-home-mode',"");
        },
        changeHomeMode(){
            this.showMode = 'kxjList';
        },
        jumpScModel(cname){
            this.categoryName = cname+"&"+Math.random();
            this.showMode = "list";
        },
    },
}

</script>

<style scoped>
.kx-home-content-box{
    width: 100%;
    height: auto;
    margin: auto;
    background-color: #fff;
    border-radius: 28px;
}
.kx-head-container{
    width: 100%;
    height: 54px;
    display: flex;
    margin: auto;
    padding: 10px 10px 8px 10px;
}
.kx-left-head-container{
    width: 200px;
    height: 44px;
    cursor: pointer;
    padding-left: 10px;
    padding-top: 9px;
}
.kx-right-head-container{
    width: calc(100% - 400px);
    height: 44px;
    text-align: center;
    font-size: 22px;
    color: #0d55a4;
    line-height: 44px;
    font-weight: bold;
    font-family: JiangCheng-600,sans-serif;
}
.home-img-container{
    width: 100%;
    height: auto;
    padding: 0 20px 0 20px;
    box-sizing: border-box;
}
.home-line-container{
    width: 100%;
    height: auto;
    display: flex;
    margin-bottom: 30px;
    gap: 10px;
}
.home-line-item{
    width: 288px;
    height: 157px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, .04);
    cursor: pointer;
}
.home-kx-line-item{
    width: 25%;
    height: auto;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, .04);
    cursor: pointer;
}
.line-img-100{
    width: 100%;
    height: 100%;
    border-radius: 8px;
}

</style>